import type { ChargeCard } from "@shared/components/charge-card-select/types";
import { i18n } from "@shared/app/i18n";
import { CONFIG } from "@shared/config";
import { maybeSpread } from "@chargetrip/frontend-utilities";

const {
  features: {
    station: {
      pricing: { defaultChargeCards, includeAdHocChargeCard },
    },
  },
} = CONFIG;

export const adHocChargeCard: ChargeCard = {
  productName: i18n.global.t(
    "panels.station.content.chargeCards.defaultPricing",
  ),
  partnerName: "AdHoc",
  partnerId: "AdHoc",
  type: "ad_hoc",
};

export const getDefaultChargeCards = (): [ChargeCard, ...ChargeCard[]] => {
  if (defaultChargeCards?.length) {
    return [
      ...maybeSpread(includeAdHocChargeCard, adHocChargeCard),
      ...defaultChargeCards,
    ] as [ChargeCard, ...ChargeCard[]];
  }

  return [adHocChargeCard];
};

export const isSameChargeCard = (
  chargeCard1: ChargeCard,
  chargeCard2: ChargeCard,
): boolean => {
  if (chargeCard1.type === "ad_hoc" && chargeCard2.type === "ad_hoc")
    return true;

  // One of them is not ad_hoc so can't be matching.
  if (chargeCard1.type === "ad_hoc" || chargeCard2.type === "ad_hoc")
    return false;

  return (
    chargeCard1.partnerId === chargeCard2.partnerId &&
    chargeCard1.productName === chargeCard2.productName
  );
};
